import { createContext } from 'react';

export const SubscriptionContext = createContext({ error: false, unpaid: false });
SubscriptionContext.displayName = 'SubscriptionContext';
